import { createReducer, on } from '@ngrx/store';
import { setDigitalization } from './digitalization.actions';
import { DigitalizationConfig } from '@/app/_core/domain/models/digitalization/digitalization.model';

export interface DigitalizationState {
  digitalization: DigitalizationConfig;
}

export const initialDigitalizationState: DigitalizationState = {
  digitalization: null
};

export const reducer = createReducer<DigitalizationState>(
  initialDigitalizationState,
  on(setDigitalization, (state, action) => ({
    ...state,
    digitalization: action.payload.digitalization
  }))
);
